import { render } from 'preact';
import type { ComponentChildren } from 'preact';
import { AuthGate } from '../components/AuthGate';
import { Shell } from '../shell/Shell';

import '../../../../trading-suite/ordo-theme.css';
import '../../../../trading-suite/ordo-approved-ui.css';

// Single mount path for every route: the cockpit shell + page render only AFTER the
// Oculus-Clipeus gate (AuthGate) confirms an authenticated session. Centralising this is
// what makes "every page is gated" an invariant — no per-entry divergence, and the
// verify-gate build guard asserts every *-main.tsx mounts through here (never raw render()).
export function mountApp(active: string, page: ComponentChildren): void {
  const root = document.getElementById('app');
  if (!root) return;
  render(
    <AuthGate>
      <Shell active={active}>{page}</Shell>
    </AuthGate>,
    root,
  );
}
